export default "__VITE_ASSET__a06e7a6e__"